export const getDescription = ({ tab, dumbUser, customLiteral, isWeb }) => {
    let literalName = customLiteral || tab.name;
    let name;
    let finalDescription = tab.description || null;
    if (isWeb) return finalDescription || literalName;
    if (dumbUser && finalDescription) name = `${finalDescription} (${literalName})`;
    else if (!dumbUser && finalDescription) name = `${literalName} (${finalDescription})`;
    else name = literalName;
    return name;
};

const observer = new MutationObserver(function (mutations) {
    mutations.forEach((current) => {
        current.addedNodes.forEach((node) => {
            if (node.classList?.length > 0 && node.classList.contains('intercom-lightweight-app')) {
                intercomHideAndShow(null, true);
            }
        });
    });
});

export function intercomHideAndShow(action, filters, isObserver) {
    let intercomElement = document.querySelector('.intercom-lightweight-app') || null;
    if (!intercomElement) intercomElement = document.getElementById('intercom-container') || null;

    if (intercomElement && action) {
        if (action === 'hide') {
            intercomElement.style.display = 'none';
            return;
        }
        if (action === 'show') {
            intercomElement.style.display = 'block';
            return;
        }
    }

    let shouldHide = false;

    const isFiltersOpen = filters?.show;

    if (isFiltersOpen) {
        shouldHide = true;
    }

    if (intercomElement && shouldHide) intercomElement.style.display = 'none';
    if (intercomElement) intercomElement.style.display = 'block';

    // Disconnect the observer because it's only necessary after the first load to
    // check if the intercom has to be hidden
    if (isObserver) observer.disconnect();
}

export function intercomHideForList(data, list, offset = 3) {
    const rowIndex = data.node.rowIndex;
    const length = list?.length;

    return length !== undefined && rowIndex >= length - offset ? 'hide' : 'show';
}
